(ns practitest.frontend.forms3.run.attachments
  (:require
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.attachments3 :as attachments]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(defn run-attachment-section [{:keys [entity-type entity-id attachable-type edit-permissions? edit-locked? upload-locked?]}]
  (let [{:keys [max-attachments max-attachment-size]} @(re-frame/subscribe [::subs/options])
        editable?    (and edit-permissions? (not edit-locked?))
        options-atom (atom {:permissions {:can-upload?    (and editable? (not upload-locked?))
                                          :can-preview?   true
                                          :can-download?  true
                                          :can-rename?    editable?
                                          :can-delete?    editable?
                                          :can-copy-link? true}
                            :max-attachments     max-attachments
                            :max-attachment-size max-attachment-size})
        event-opts   {:entity-type     entity-type
                      :entity-id       entity-id
                      :attachable-type attachable-type}]
    [:div.run-step-run-attachments
     [:div.run-step-attachment-header
      [icons/mux-paperclip]
      [:span.run-step-field-label
       (get-translation "run.steps.run-attachments" "Run Attachments")]]
     [attachments/attachments-view
      {:options                 options-atom
       :attachments             (re-frame/subscribe [::attachments/attachments entity-type entity-id])
       :notifications           (re-frame/subscribe [::attachments/notifications entity-type entity-id])
       :entity-type             entity-type
       :entity-id               entity-id
       :show-search?            false
       :install-paste-listener? false
       :actions                 {:on-upload              (fn [file]
                                                           (re-frame/dispatch [::attachments/upload file event-opts]))
                                 :on-delete              (fn [attachment]
                                                           (re-frame/dispatch [::attachments/delete attachment event-opts]))
                                 :on-rename              (fn [attachment new-name]
                                                           (re-frame/dispatch [::attachments/rename attachment new-name event-opts]))
                                 :on-clear-notifications #(re-frame/dispatch [::attachments/clear-notifications entity-type entity-id])
                                 :on-cancel-uploads      #(re-frame/dispatch [::attachments/cancel-uploads entity-type entity-id])}}]]))
